import { Component, Input } from '@angular/core';

const RADIUS = 9;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

@Component({
  selector: 'app-progress-ring',
  templateUrl: './progress-ring.component.html',
  styleUrls: ['./progress-ring.component.scss'],
  standalone: false,
})
export class ProgressRingComponent {
  readonly radius = RADIUS;
  readonly circumference = CIRCUMFERENCE;

  /** Progress as a 0-1 ratio. Values outside the range are clamped. */
  @Input() progress = 0;

  get dashOffset(): number {
    const clamped = Math.max(0, Math.min(1, this.progress));
    return CIRCUMFERENCE * (1 - clamped);
  }
}
